export const data = {
  buttons: [
    {
      label: 'Private parking company',
      id: 'private',
    },
    {
      label: 'Council or local authority',
      id: 'council',
    },
    {
      label: 'Police',
      id: 'police',
    },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/f668960b0c83-tooliconticket.jpg',
  },
  title: 'Who issued the parking ticket?',
}
